import { useCallback } from "react";
import styled from "styled-components";
import {
  PRIMARY_DARK_GREEN,
  SECONDARY_DARK_GREEN,
} from "../../constants/color";
import { useNavigation } from "../../hooks/useNavigation";

type Props = {
  text: string;
  href: string;
};

export const Link: React.FC<Props> = ({ text, href }) => {
  const { navigateToPage } = useNavigation();

  const handleClick = useCallback(() => {
    navigateToPage(href);
  }, []);

  return <StyledLink onClick={handleClick}>{text}</StyledLink>;
};

const StyledLink = styled.a`
  background-color: transparent;
  color: ${PRIMARY_DARK_GREEN};
  border: none;
  text-decoration: underline;
  transition: color 0.2s ease-in-out;
  cursor: pointer;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;

  &:hover {
    color: ${SECONDARY_DARK_GREEN};
    text-decoration: none;
  }

  &:disabled {
    color: #999999;
    text-decoration: none;
  }
`;
